module.exports = __webpack_public_path__ + "img/beats-headphones.89ed89b1.svg";